import React, { useEffect, useCallback, useState} from 'react';
import {legato, rollSteps} from "pattern/utils/legato.js";
import {ungroupSteps, groupSteps} from "pattern/groups/stepGroups.js";
import ConditionedCheckmark from 'components/ConditionedCheckmark.js';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import {connect} from 'react-redux';
import {
    setStepsGroupMode
} from 'actions/index.js';

const StepsButton = ({selectedSteps, track, setGroupMode, groupMode}) => { 
    let [toggled, setToggled] = useState(false);

    const onClickGroupSteps = useCallback(() => {
        groupSteps(selectedSteps, track);
    }, [selectedSteps]);

    const onClickUngroup  = useCallback(() => {
        ungroupSteps(selectedSteps);
    }, [selectedSteps]);

    const onClickRollSteps = useCallback(() => {
        rollSteps(track, selectedSteps);
    }, [selectedSteps]);

    const onClickLegatoSteps = useCallback(() => {
        legato(track, selectedSteps);
    }, [selectedSteps]);

    if (!selectedSteps || selectedSteps.length === 0) {
        return [];
    }

    return (
        <ButtonDropdown
          className="steps-dropdown"
          show={toggled ? "true" : "false"}
          isOpen={toggled}
          toggle={() => setToggled(!toggled)}>
          <DropdownToggle size="sm" caret color="primary">
            {selectedSteps.length} steps
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem
              onClick={() => setGroupMode(!groupMode)}
              size="sm">
              Groups Mode 
              <ConditionedCheckmark
                className="group-checkmark"
                condition={groupMode}/>
            </DropdownItem>
            <DropdownItem
              onClick={onClickGroupSteps}
              size="sm">
              Group Steps
            </DropdownItem>
            <DropdownItem
              onClick={onClickUngroup}
              size="sm">
              Un-group Steps
            </DropdownItem>
            <DropdownItem
              onClick={onClickLegatoSteps}
              size="sm">
              Legato Steps
            </DropdownItem>
            <DropdownItem
              onClick={onClickRollSteps}
              size="sm">
              Roll Steps
            </DropdownItem>
         </DropdownMenu>
        </ButtonDropdown>
    );
}

const mapStateToProps = (state, props) => {
  return {
      groupMode: state.groups.stepsGroupMode
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setGroupMode: (x) => dispatch(setStepsGroupMode(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StepsButton);
